import { Path, UseFormReturn } from 'react-hook-form';
import { BasePaymentDataSchemaType } from '../../data-schemas/payment-data-schema';
import { FormControl, FormField, FormItem, FormMessage } from '../../../../../../ui/components/ui/form';
import { Input } from '../../../../../../ui/components/ui/input';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';

interface InvoiceDataFormItemsProps<T extends BasePaymentDataSchemaType> {
  form: UseFormReturn<T>;
  isValidating: boolean;
  ibanValid: boolean | undefined;
  bicValid: boolean | undefined;
  useInvoice: boolean;
}

export const InvoiceDataFormItems = <T extends BasePaymentDataSchemaType>({
  form,
  isValidating,
  ibanValid,
  bicValid,
  useInvoice
}: InvoiceDataFormItemsProps<T>) => {
  return (
    <>
      {!useInvoice ? (
        <>
          <div className="w-full relative">
            <FormField
              control={form.control}
              name={'iban' as Path<T>}
              render={({ field }) => (
                <FormItem className="flex flex-col bg-white rounded-lg">
                  <FormControl>
                    <Input {...field} placeholder="IBAN *" value={field.value as string} />
                  </FormControl>
                  <div className="absolute right-3">
                    {isValidating && <Loader2 className="h-5 w-5 text-gray-400 animate-spin" />}
                    {!isValidating && ibanValid === true && <CheckCircle2 className="h-5 w-5 text-green-500" />}
                    {!isValidating && ibanValid === false && <XCircle className="h-5 w-5 text-red-500" />}
                  </div>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <div className="w-full relative">
            <FormField
              control={form.control}
              name={'bic' as Path<T>}
              render={({ field }) => (
                <FormItem className="flex flex-col bg-white rounded-lg">
                  <FormControl>
                    <Input {...field} placeholder="BIC *" value={field.value as string} />
                  </FormControl>
                  <div className="absolute right-3">
                    {isValidating && <Loader2 className="h-5 w-5 text-gray-400 animate-spin" />}
                    {!isValidating && bicValid === true && <CheckCircle2 className="h-5 w-5 text-green-500" />}
                    {!isValidating && bicValid === false && <XCircle className="h-5 w-5 text-red-500" />}
                  </div>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <div className="w-full">
            <FormField
              control={form.control}
              name={'invoiceMail' as Path<T>}
              render={({ field }) => (
                <FormItem className="flex flex-col bg-white rounded-lg">
                  <FormControl>
                    <Input
                      {...field}
                      placeholder="Alternative E-Mail für Rechnungen"
                      onChange={(e) => {
                        field.onChange(e);
                        form.trigger('invoiceMail' as Path<T>);
                      }}
                      value={field.value as string}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
        </>
      ) : (
        <div className="flex gap-2 items-center w-full">
          <div>
            <Input type="radio" checked={true} className="w-5 h-5 p-0" readOnly={true} />
          </div>
          <div className="flex flex-col">
            <h3 className="text-xl grow">Rechnung</h3>
            <p className="text-gray-400 text-sm">(7 Tage Zahlungsziel nach Rechnungseingang)</p>
          </div>
        </div>
      )}
    </>
  );
};
